import layout from '@/views/layout/layout.vue'
const cameraList = r => require.ensure([], () => r(require('@/views/marketing/camera/list.vue')), 'group-marketing-camera')

const marketingCamera = [
  {
    path: '/marketing/camera',
    name: 'marketing-camera',
    component: layout,
    redirect: '/marketing/camera/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: cameraList,
        name: 'marketing-camera-list',
        meta: {
          displayName: '拍照明细管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingCamera



// WEBPACK FOOTER //
// ./src/router/marketing/camera.js